var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8142 36H0V4.05396H19.8673L27.8142 11.1531V36Z",
    fill: "#42A5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7876 32.4504H3.97339V0.504395H23.8407L31.7876 7.60352V32.4504Z",
    fill: "#90CAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2976 8.49088H22.8474V1.83545L30.2976 8.49088Z",
    fill: "#E1F5FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3907 22.068C16.3907 17.8973 19.9668 18.1635 19.9668 15.6788C19.9668 15.0576 19.7681 13.8153 17.9801 13.8153C15.9933 13.8153 15.894 15.2351 15.894 15.5901H13.2119C13.2119 14.9689 13.5099 11.863 17.9801 11.863C22.5495 11.863 22.6489 15.0576 22.6489 15.6788C22.6489 18.7847 18.8741 19.2284 18.8741 22.1568H16.3907V22.068ZM16.192 25.1739C16.192 24.9964 16.192 23.8428 17.6821 23.8428C19.0728 23.8428 19.1721 24.9964 19.1721 25.1739C19.1721 25.5288 18.9734 26.4162 17.6821 26.4162C16.3907 26.4162 16.192 25.5288 16.192 25.1739Z",
    fill: "#1976D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.5eb18d96379a7dc9b74dfea7b1c94178.svg";
export { ForwardRef as ReactComponent };